<template>
  <fieldset
    class="color-variant"
    v-if="colors.length > 0">
    <legend
      class="is-sr-only"
      id="legend-shade">
      {{ legendName }}
    </legend>
    <div class="productItemId">{{ productid[activeShade].id }}</div>
    <div class="productItemActiveId">{{ sfcccolorsdetails[activeShade].ean }}</div>
    <div class="color-variant__wrapper">
      <template v-if="!smallScreen">
        <div class="color-variant__name">
          <p class="title">Color:</p>
          <p class="name">{{ colors[activeShade].name }}</p>
        </div>

        <div class="color-variant__slider">
          <slider
            @pageChange="a11ySlider"
            :per-page-custom="[[768, 4]]"
            :loop="false"
            :scroll-per-page="true"
            :start-at="0"
            :navigation-enabled="true"
            :pagination-enabled="false"
            :swipe-on-desktop="false"
            :next-panel-text="a11yNextPanelText"
            :previous-panel-text="a11yPreviousPanelText"
            ref="slider">
            <slide
              v-for="(color, index) in colors"
              :key="index">
              <input
                @click="setAnalytics(color.tagging), selectActiveShade(color)"
                type="radio"
                name="color-shade"
                class="is-sr-only"
                :id="`color-shade-${index}`"
                :value="index"
                v-model="activeShade">
              <label
                class="color-variant__shade"
                :class="{ 'active': activeShade === index }"
                :for="`color-shade-${index}`" :id="color.id" @click="getsfccPrice();">
                <svg
                  aria-hidden="true"
                  viewBox="0 0 25 25">
                  <path
                    :fill="color.hex"
                    fill-rule="nonzero"
                    d="M0 0h25v25H0z"/>
                </svg>
                <span class="is-sr-only">{{ color.name }}</span>
              </label>
            </slide>
          </slider>
        </div>
      </template>
      <template v-else-if="smallScreen">
        <panel
          :a11y-close-panel-text="a11yClosePanelText"
          legend-name="test legend"
          ref="panel">
          <button
            id="current-shade"
            slot="toggleButton"
            slot-scope="scope"
            @click="scope.panelToggler"
            :aria-expanded="scope.expanded ? 'true' : 'false'"
            aria-labelledby="legend-shade current-shade"
            class="color-variant__selector current-shade">
            <svg
              aria-hidden="true"
              class="color-variant__shade">
              <path
                :fill="colors[activeShade].hex"
                fill-rule="nonzero"
                d="M0 0h25v25H0z"/>
            </svg>
            <span class="is-sr-only">{{ colors[activeShade].name }}</span>
          </button>
          <slider
            @pageChange="a11ySlider"
            :per-page="4"
            :is-pagination-clickable="false"
            :loop="false"
            :scroll-per-page="true"
            :start-at="0"
            :navigation-enabled="true"
            :pagination-enabled="true"
            :swipe-on-desktop="false"
            :next-panel-text="a11yNextPanelText"
            :previous-panel-text="a11yPreviousPanelText"
            ref="slider">
            <slide
              v-for="(color, index) in colors"
              :key="index">
              <input
                panel-focusable
                type="radio"
                name="color-shade"
                class="is-sr-only"
                @click="setAnalytics(color.tagging),selectedVariant(color.ean),selectActiveShade(color)"
                :id="`color-shade-${index}`"
                :value="index"
                v-model="activeShade">
              <label
                class="color-variant__shade"
                :class="{ 'active': activeShade === index }"
                :for="`color-shade-${index}`" :id="color.id" @click="getsfccPrice();">
                <svg
                  aria-hidden="true"
                  viewBox="0 0 25 25">
                  <path
                    :fill="color.hex"
                    fill-rule="nonzero"
                    d="M0 0h25v25H0z"/>
                </svg>
                <span class="is-sr-only">{{ color.name }}</span>
              </label>
            </slide>
          </slider>
          <div class="color-variant__name">
            <p class="name">{{ colors[activeShade].name }}</p>
          </div>
        </panel>
      </template>
    </div>
  </fieldset>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import { eventBus } from '@EventBus';
  import Panel from '@Feature/Panel/code/Scripts/components/panel.vue';
  import Slide from '@Feature/Slider/code/Scripts/components/slide/slide';
  import Slider from '@Feature/Slider/code/Scripts/components/slider/slider';
  import { mapActions } from 'vuex';

  export default {
    name: 'color-variant',

    components: {
      Panel,
      Slide,
      Slider
    },

    props: {
      a11yClosePanelText: { type: String, required: false, default: 'Close panel' },
      a11yNextPanelText: { type: String, required: false, default: 'Next panel' },
      a11yPreviousPanelText: { type: String, required: false, default: 'Previous panel' },
      colors: { type: Array, required: true },
      productid: { type: Array, required: true },
      sfcccolorsdetails: { type: Array, required: true },
      legendName: { type: String, required: true, default: 'Shade' },
    },

    data() {
      return {
        activeShade: 0,
        shades: [],
        smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
      };
    },

    watch: {
      activeShade() {
        this.announceColorSelection();
      },
    },
    mounted() {
      /* istanbul ignore next */
      eventBus.$on('mediaquery::changed', () => {
        this.smallScreen = !window.matchMedia('(min-width: 1024px)').matches;
      });

      this.announceColorSelection();
      this.getsfccPrice();
      /* istanbul ignore else */
      if (this.smallScreen) {
        /**
         * add listener to carousel navs,
         * it should close panel on blur
         * a11y criteria
         */
        const navs = this.$refs.slider.$el.querySelectorAll('.slider__navigation-button');
        Array.prototype.forEach.call(navs, (nav) => {
          /* istanbul ignore next */
          nav.addEventListener('blur', () => {
            this.$refs.panel.closeOnBlur();
          });
        });
      }
      window.eventBus.$on('clickandcollectEnabled', payload => {
          if(payload != true){
            this.$on('showRetailer',() => {
            window.eventBus.$emit('showRetailerPopup', true);
            });
          }
      });
    },

    methods: {
      /**
       * Pushes given data to dataLayer
       * @param {object} dataObject - Data object to push
       * @returns {undefined}
       */
     setAnalytics(dataObject) {
        let getStatus = Boolean(this.getCookie('vtoActivated'));
        if (getStatus) {
          dataObject.ecommerce.detail.products[0].dimension49 = 'activated';
        }
        AnalyticsHandler.pushDataLayer(dataObject);
      },
      getCookie(cName) {
        var name = cName + '=';
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
      },
      isUsingKeyboard() {
        return document.body.classList.contains('is-using-keyboard');
      },

      a11ySlider() {
        const slidesOnPage = this.$refs.slider.currentPerPage;
        const currentSlide = this.$refs.slider.currentPage;
        /* istanbul ignore else */
        if (this.isUsingKeyboard()) {
          this.activeShade = currentSlide * slidesOnPage;
          this.$nextTick(() => {
            this.$refs.slider.$children[this.activeShade].$el.querySelector('input').focus();
          });
        }
      },
      getsfccPrice: function(activeShade) {
        setTimeout(() => {
          var sfccPriceRowExist = document.getElementById('sfccPrice');
          if (sfccPriceRowExist) {
            var dataSfccPrice = this.sfcccolorsdetails[this.activeShade].sfccPrice;
            var sfccPriceRow = document.getElementById('sfccPrice');
            sfccPriceRow.innerHTML = dataSfccPrice;
            var afterPay = document.getElementsByTagName('afterpay-placement')[0];
            if (afterPay) {
              afterPay.setAttribute('data-amount', dataSfccPrice);
            }
          }
        },300);
      },
      announceColorSelection() {
        const selectedColorData = {
          name: this.colors[this.activeShade].name,
          imgUrl: this.colors[this.activeShade].img
        };
        //var dataID= this.productid[this.activeShade].id;
        //var activeSelect = document.getElementsByClassName("js-select-option");
        //activeSelect.id = dataID;

        this.selectPreferredProductVariant(selectedColorData);
      },
      selectActiveShade(activeShade) {
        window.eventBus.$emit('selectActiveShade', activeShade);
        window.eventBus.$emit('SelectVarientPdpChangedActionColor', activeShade.ean);
      },
      selectedVariant(variant){
       window.eventBus.$emit('selectedVarientSize', variant);
      },
      ...mapActions(['selectPreferredProductVariant'])
    },

  };
</script>

<style lang='scss' src="./color-variant.scss"></style>
